import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';

const SectionHeader = dynamic(() => import('sections/Resources/SectionHeader'));
const SectionCards = dynamic(() => import('sections/Resources/SectionCards'));

export default function ResourcesPage() {
  return (
    <div className="resources">
      <SectionHeader/>
      <SectionCards/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Freight Forwarding Resources: Guides & Insights | DF Alliance',
      description: 'Explore DF Alliance’s freight forwarding resources, including guides, a dictionary, and industry insights to support logistics and supply chain professionals.',
      path: '/resources',
    },
  };
};

ResourcesPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};